import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import MapWithCoachesModal from "../../../components/Modals/StudentFlow/Favorites/MapWithCoachesModal/MapWithCoachesModal";
import CoachFiltesrModal from "../../../components/Modals/StudentFlow/Favorites/CoachFiltersModal/CoachFiltersModal";
import { CoachCardWithFavouriteIconMobile } from "../../../stories/CoachCardWithFavouriteIconMobile/CoachCardWithFavouriteIconMobile";
import { InputWithSearchIcon } from "../../../stories/InputWithSearchIcon/InputWithSearchIcon";
import classes from "./FavoritesMobile.module.css";
import Colors from "../../../stories/assets/Colors";
import Fonts from "../../../stories/assets/Fonts";
import { ReactSVG } from "react-svg";
import { CancelIconBlack, SearchOnMap } from "../../../constant/imagePath";

const StudentFlowFavoritesMobile = () => {
  const [searchValue, setSearchValue] = useState("");
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const [mapModal, setMapModal] = useState(false);
  const [filterModal, setFilterModal] = useState(false);

  const favCardsArr = [
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
    {
      firstName: "Mackenzie",
      lastName: "McDonald",
      description:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis...",
      distance: "0.6 m away",
      rating: 5.0,
      price: 75,
      speciality: "Tennis",
    },
  ];

  return (
    <div>
      {/* Header */}
      <div
        style={{
          borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
        }}
        className={[classes.header].join(" ")}
      >
        <div className={[classes.mainContent].join(" ")}>
          <ReactSVG
            src={CancelIconBlack}
            beforeInjection={(svg) => svg.classList.add(classes.cancelIcon)}
            onClick={() => console.log(false)}
          />
          <p
            style={{
              ...Fonts.b3,
              color: Colors.neutralShadesOfNero,
              lineHeight: "14px",
              lineHeight: "20px",
            }}
            className={[classes.pl16].join(" ")}
          >
            Favorites
          </p>
        </div>
      </div>

      <Container fluid className={classes.container}>
        <Col md={12} className={classes.marginBlock15}>
          <InputWithSearchIcon
            isShowFilter={true}
            state={searchValue}
            setter={setSearchValue}
            onFilter={setIsOpenFilter}
          />
        </Col>
        <div className={classes.cardsContainer}>
          {favCardsArr?.map((item, index) => (
            <div className={classes.card}>
              <CoachCardWithFavouriteIconMobile
                key={index}
                showFavoriteIcon={true}
                data={item}
              />
            </div>
          ))}
        </div>
        {/* Search On Map Popup */}
        <div
          className={`${classes.searchOnMapPopup}`}
          style={{ background: Colors.neutralShadesOfNero }}
          onClick={() => setMapModal(true)}
        >
          <ReactSVG
            src={SearchOnMap}
            beforeInjection={(svg) => svg.classList.add(classes.mapViewIcon)}
          />
          <span
            style={{ ...Fonts.b2, lineHeight: "20px", color: Colors.white }}
          >
            Search on Map
          </span>
        </div>
      </Container>
      <MapWithCoachesModal show={mapModal} setShow={setMapModal} />
      <CoachFiltesrModal show={isOpenFilter} setShow={setIsOpenFilter} />
    </div>
  );
};

export default StudentFlowFavoritesMobile;
